import { Colors } from '@ab-core/colors';
import { RADIUS } from '@ab-core/radius';
import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import 'tippy.js/dist/svg-arrow.css';
import type { TooltipProps } from '.';

export const TippyStyled = styled(Tippy)`
    width: 220px;
    background-color: white;
    border-radius: ${RADIUS.ROUNDED};
    border: 1.5px solid ${Colors.gray30};
    color: ${Colors.gray70};
    line-height: 1.125rem;
    padding: 10px;
    .tippy-content {
        padding: 0;
    }

    .tippy-svg-arrow {
        width: 20px;
        height: 20px;
        > svg {
            color: ${Colors.gray30};
            width: 100%;
            height: 100%;
        }
    }

    &[data-placement^='left'] > .tippy-svg-arrow {
        left: 15px;
    }

    &[data-placement^='right'] > .tippy-svg-arrow {
        right: 15px;
    }
`;

export const Wrapper = styled.div<Omit<TooltipProps, 'showTooltip'>>`
    ${({ fluid }) => fluid && 'width: 100%;'}
`;
